const TOGGLE_DRAWER: string = "TOGGLE_DRAWER";

export const types = {
  TOGGLE_DRAWER
};
